"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vars_1 = __importDefault(require("../config/vars"));
const fetchJson_1 = __importDefault(require("../utils/fetchJson"));
function buildQuery(host) {
    return {
        operationName: 'getProjectInfoByHost',
        query: 'query getProjectInfoByHost($host: String!) {getProjectInfoByHost(host: $host) {id displayName area feVendorKey}}',
        variables: { host },
    };
}
function buildRequest(host) {
    return {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(buildQuery(host)),
    };
}
function getProjectInfoByHost(host) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield (0, fetchJson_1.default)(vars_1.default.apolloUri, buildRequest(host));
        return response.data.getProjectInfoByHost;
    });
}
exports.default = getProjectInfoByHost;
